<div class="p-3 box h-100 overflow-auto crm-scroll">
  <h1>{{ 'company_settings' | translate }}</h1>

  <!-- Tabs -->
  <app-tabs-v2 [tabList]="tabs" (onSelectTab)="onChangeTab($event)" />

  <!-- General Tab -->
  @if (selectedTab?.value === CompanySettingsTab.GENERAL) {
    <div class="bg-white rounded shadow p-4 mt-3">
      <div class="setting-box">
        @if (settingsForm) {
          <div class="d-flex flex-column gap-2 text-black" [formGroup]="settingsForm">
            <div class="w-100 d-flex justify-content-between align-items-center">
              <label>{{ 'company_name' | translate }}:</label>
              <app-input
                class="w-25"
                [formControl]="settingsForm.controls.name"
              />
            </div>
            <div class="w-100 d-flex flex-column gap-1">
              <div class="d-flex justify-content-between align-items-center">
                <label>{{ 'subdomain' | translate }}:</label>
                <app-input
                  class="w-25"
                  [formControl]="settingsForm.controls.subdomain"
                  [disabled]="!isEditSubdomain()"
                />
              </div>
              <small class="text-muted">{{ 'you_can_change_the_company\'s_subdomain_only_for_the_first_3_days' | translate }}</small>
            </div>
            <div class="w-100 d-flex flex-column gap-1">
              <div class="d-flex justify-content-between align-items-center gap-4 max-md:!items-stretch max-md:flex-col">
                <label>{{ 'api_key' | translate }}:</label>
                <div class="flex w-[40%] min-w-[280px] max-w-[560px] items-center justify-end gap-2 max-md:w-full max-md:min-w-0 max-md:flex-wrap max-md:justify-start">
                  <app-button
                    [btnType]="'icon'"
                    [disabled]="apiKeyRegenerating"
                    [matTooltip]="'regenerate_api_key' | translate"
                    matTooltipPosition="above"
                    (onChangeClick)="regenerateApiKey()"
                  >
                    <app-icon>autorenew</app-icon>
                  </app-button>
                  <button
                    type="button"
                    class="click-css flex h-10 min-w-0 flex-1 items-center gap-2 overflow-hidden rounded border border-[#d1d8e0] bg-white py-0 pr-2 pl-3 text-left text-[#495057] disabled:cursor-default disabled:bg-[#f8f9fa] disabled:text-[#adb5bd]"
                    [disabled]="!apiKey"
                    (click)="copyApiKey()"
                    [title]="'copy_to_clipboard' | translate"
                  >
                    <span class="min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap font-mono leading-[38px]">{{ maskedApiKey }}</span>
                    <span class="flex h-7 w-7 flex-[0_0_28px] items-center justify-center text-[#495057]">
                      <app-icon>content_copy</app-icon>
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div class="w-100 d-flex justify-content-between align-items-center">
              <label>{{ 'time_zone' | translate }}:</label>
              <app-dropdown
                class="w-25"
                bindLabel="name"
                bindValue="id"
                [items]="timeZones"
                [closeOnSelect]="true"
                (onValueChange)="onChangeZone($event)"
                [formControl]="settingsForm.controls.time_zone"
              >
              </app-dropdown>
            </div>
            <div class="w-100 d-flex justify-content-between align-items-center">
              <label>{{ 'color' | translate }}:</label>
              <app-color
                class="w-25"
                [input]="settingsForm.controls.primary_color.value"
                [formControl]="settingsForm.controls.primary_color"
                [colors]="colors"
              >
              </app-color>
            </div>
            <div class="w-100 d-flex justify-content-between align-items-center">
              <label>{{ 'name_format' | translate }}:</label>
              <app-select
                class="w-25"
                [formControl]="settingsForm.controls.name_format"
                [options]="nameFormatOptions"
                optionValue="value"
                optionLabel="label"
                [isTranslate]="true"
              />
            </div>
            <div class="w-100 d-flex justify-content-between align-items-center">
              <label>{{ 'chat_unpin' | translate }}:</label>
              <app-toggle
                [checked]="settingsForm.controls.is_chat_unpin.value"
                (change)="settingsForm.controls.is_chat_unpin.setValue($event)"
              ></app-toggle>
            </div>
            <div class="w-100 d-flex justify-content-between align-items-center gap-4">
              <div class="flex min-w-0 flex-col">
                <label>{{ 'chat_manager_assignment' | translate }}:</label>
                <small class="text-muted">{{ 'chat_manager_assignment_hint' | translate }}</small>
              </div>
              <app-toggle
                [checked]="settingsForm.controls.is_chat_manager_assignment.value"
                (change)="settingsForm.controls.is_chat_manager_assignment.setValue($event)"
              ></app-toggle>
            </div>
          </div>
        }
        <div class="d-flex justify-content-end gap-2">
          <app-button (onChangeClick)="saveChanges()">{{ 'save' | translate }}</app-button>
        </div>
      </div>
    </div>
  }

  <!-- Security Tab -->
  @if (selectedTab?.value === CompanySettingsTab.SECURITY) {
    <div class="bg-white rounded shadow p-4 mt-3">
      <div class="setting-box">
        <!-- IP Restriction Toggle -->
        @if (settingsForm) {
          <div class="d-flex justify-content-between align-items-center mb-3" [formGroup]="settingsForm">
            <label class="text-black">{{ 'ip_restriction_only' | translate }}:</label>
            <app-toggle
              [checked]="settingsForm.controls.is_only_ip.value"
              (change)="settingsForm.controls.is_only_ip.setValue($event)"
            ></app-toggle>
          </div>
        }
        <!-- IP Addresses Table -->
        <div class="ip-section">
          <h5 class="mb-3">{{ 'allowed_ip_addresses' | translate }}</h5>
          <!-- Add IP Form -->
          <div class="add-ip-form mb-3">
            <app-input [(ngModel)]="newIp" [placeholder]="'ip_address' | translate" />
            <app-input [(ngModel)]="newIpDescription" [placeholder]="'description' | translate" />
            <app-select
              [options]="userOptions"
              optionLabel="label"
              [isAvatar]="true"
              optionValue="id"
              [type]="SelectType.Multiple"
              [showToggleAll]="false"
              [placeholder]="'select_managers' | translate"
              [loading]="usersLoading"
              [disabled]="usersLoading || userOptions.length === 0"
              [showClear]="true"
              [appendTo]="'body'"
              [(ngModel)]="newIpManagerSelection"
              [ngModelOptions]="{ standalone: true }"
            ></app-select>
            <app-button (onChangeClick)="addIpAddress()">
              {{ 'add' | translate }}
            </app-button>
          </div>
          @if (!usersLoading && userOptions.length === 0) {
            <div class="text-muted small">
              {{ 'nothing_found' | translate }}
            </div>
          }
          <!-- IP Addresses List -->
          @if (ipAddresses.length > 0) {
            <div class="ip-list">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>{{ 'ip_address' | translate }}</th>
                    <th>{{ 'description' | translate }}</th>
                    <th>{{ 'managers' | translate }}</th>
                    <th style="width: 100px">{{ 'actions' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (ip of ipAddresses; track trackByIp(i, ip); let i = $index) {
                    <tr>
                      <td>{{ ip.ip }}</td>
                      <td>{{ ip.description || '-' }}</td>
                      <td>
                        @if (userOptions.length === 0 && !usersLoading) {
                          —
                        }
                        @if (userOptions.length > 0 || usersLoading) {
                          <app-select
                            [options]="userOptions"
                            optionLabel="label"
                            [isAvatar]="true"
                            optionValue="id"
                            [type]="SelectType.Multiple"
                            [showToggleAll]="false"
                            [placeholder]="ip.manager_ids.length > 0 ? ('select_managers' | translate) : '—'"
                            [disabled]="userOptions.length === 0"
                            [loading]="usersLoading"
                            [showClear]="true"
                            [appendTo]="'body'"
                            [(ngModel)]="ip.manager_selection"
                            [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="onManagerSelectionChange(ip, $event)"
                          ></app-select>
                        }
                      </td>
                      <td class="text-center">
                        <button class="btn btn-sm btn-danger" (click)="removeIpAddress(i)">
                          {{ 'delete' | translate }}
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
          @if (ipAddresses.length === 0) {
            <div class="text-muted">
              {{ 'no_ip_addresses' | translate }}
            </div>
          }
        </div>
        <!-- Save Button -->
        <div class="d-flex justify-content-end gap-2 mt-3">
          <app-button (onChangeClick)="saveChangesIps()">{{ 'save' | translate }}</app-button>
        </div>
      </div>
    </div>
  }

</div>
